export const isArray = (arg: any) =>
  Object.prototype.toString.call(arg) === "[object Array]";
